import { Injectable, computed, signal } from '@angular/core';

import { Constants } from '../../../providers/constants/constants';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private readonly constants = Constants;
  private readonly userSignal = signal<Record<string, unknown> | null>(this.readUser());
  private readonly tokenSignal = signal<string | null>(this.readToken());

  readonly user = this.userSignal.asReadonly();
  readonly token = this.tokenSignal.asReadonly();
  readonly isAuthenticated = computed(() => !!this.tokenSignal() && !!this.userSignal());

  setSession(token: string, user: Record<string, unknown>): void {
    localStorage.setItem(this.constants.localStorage.token, token);
    localStorage.setItem(this.constants.localStorage.user, JSON.stringify(user));
    this.tokenSignal.set(token);
    this.userSignal.set(user);
  }

  updateUser(user: Record<string, unknown>): void {
    localStorage.setItem(this.constants.localStorage.user, JSON.stringify(user));
    this.userSignal.set(user);
  }

  updateToken(token: string): void {
    localStorage.setItem(this.constants.localStorage.token, token);
    this.tokenSignal.set(token);
  }

  clearSession(): void {
    this.tokenSignal.set(null);
    this.userSignal.set(null);
  }

  private readToken(): string | null {
    const token = localStorage.getItem(this.constants.localStorage.token);
    return token && token !== 'undefined' ? token : null;
  }

  private readUser(): Record<string, unknown> | null {
    try {
      const raw = localStorage.getItem(this.constants.localStorage.user);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }
}
